// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.r2r7ARvxgqM5FyIHPVPu{flex-direction:column;justify-content:center;align-items:center;width:100%;display:flex}.fmsNwazo9CUldblUPNNj{color:var(--content-neutral-primary);margin-bottom:16px}.xs1cu0NvQsuEGW5Zv_UC{gap:8px;margin-top:20px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `r2r7ARvxgqM5FyIHPVPu`,
	"icon": `fmsNwazo9CUldblUPNNj`,
	"actions": `xs1cu0NvQsuEGW5Zv_UC`
};
export default ___CSS_LOADER_EXPORT___;
